// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/integrations.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_log } from "./log_pb.js";
/**
 * Describes the file vitesse/v1/integrations.proto.
 */
export const file_vitesse_v1_integrations = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_log]);
/**
 * Describes the message vitesse.v1.Value.
 * Use `create(ValueSchema)` to create a new message.
 */
export const ValueSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 0);
/**
 * Describes the message vitesse.v1.Row.
 * Use `create(RowSchema)` to create a new message.
 */
export const RowSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 1);
/**
 * Describes the message vitesse.v1.IntegrationCatalog.
 * Use `create(IntegrationCatalogSchema)` to create a new message.
 */
export const IntegrationCatalogSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 2);
/**
 * Describes the message vitesse.v1.IntegrationType.
 * Use `create(IntegrationTypeSchema)` to create a new message.
 */
export const IntegrationTypeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 3);
/**
 * Describes the message vitesse.v1.FieldSpec.
 * Use `create(FieldSpecSchema)` to create a new message.
 */
export const FieldSpecSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 4);
/**
 * Describes the message vitesse.v1.IntegrationDescriptor.
 * Use `create(IntegrationDescriptorSchema)` to create a new message.
 */
export const IntegrationDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 5);
/**
 * Describes the message vitesse.v1.Forward.
 * Use `create(ForwardSchema)` to create a new message.
 */
export const ForwardSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 6);
/**
 * Describes the message vitesse.v1.NamedTarget.
 * Use `create(NamedTargetSchema)` to create a new message.
 */
export const NamedTargetSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 7);
/**
 * @generated from enum vitesse.v1.NamedTarget.Mode
 */
export var NamedTarget_Mode;
(function (NamedTarget_Mode) {
    /**
     * @generated from enum value: MODE_UNSPECIFIED = 0;
     */
    NamedTarget_Mode[NamedTarget_Mode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MODE_READ = 1;
     */
    NamedTarget_Mode[NamedTarget_Mode["READ"] = 1] = "READ";
    /**
     * @generated from enum value: MODE_WRITE = 2;
     */
    NamedTarget_Mode[NamedTarget_Mode["WRITE"] = 2] = "WRITE";
})(NamedTarget_Mode || (NamedTarget_Mode = {}));
/**
 * Describes the enum vitesse.v1.NamedTarget.Mode.
 */
export const NamedTarget_ModeSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 7, 0);
/**
 * Describes the message vitesse.v1.ParamSpec.
 * Use `create(ParamSpecSchema)` to create a new message.
 */
export const ParamSpecSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 8);
/**
 * Describes the message vitesse.v1.IntegrationRuntime.
 * Use `create(IntegrationRuntimeSchema)` to create a new message.
 */
export const IntegrationRuntimeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 9);
/**
 * Describes the message vitesse.v1.ForwardStatus.
 * Use `create(ForwardStatusSchema)` to create a new message.
 */
export const ForwardStatusSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 10);
/**
 * Describes the message vitesse.v1.SchemaItem.
 * Use `create(SchemaItemSchema)` to create a new message.
 */
export const SchemaItemSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 11);
/**
 * Describes the message vitesse.v1.WriteRequest.
 * Use `create(WriteRequestSchema)` to create a new message.
 */
export const WriteRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 12);
/**
 * Describes the message vitesse.v1.WriteReply.
 * Use `create(WriteReplySchema)` to create a new message.
 */
export const WriteReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 13);
/**
 * Describes the message vitesse.v1.RowPredicate.
 * Use `create(RowPredicateSchema)` to create a new message.
 */
export const RowPredicateSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 14);
/**
 * @generated from enum vitesse.v1.RowPredicate.Op
 */
export var RowPredicate_Op;
(function (RowPredicate_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    RowPredicate_Op[RowPredicate_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: OP_EQ = 1;
     */
    RowPredicate_Op[RowPredicate_Op["EQ"] = 1] = "EQ";
    /**
     * @generated from enum value: OP_NEQ = 2;
     */
    RowPredicate_Op[RowPredicate_Op["NEQ"] = 2] = "NEQ";
    /**
     * @generated from enum value: OP_LT = 3;
     */
    RowPredicate_Op[RowPredicate_Op["LT"] = 3] = "LT";
    /**
     * @generated from enum value: OP_LTE = 4;
     */
    RowPredicate_Op[RowPredicate_Op["LTE"] = 4] = "LTE";
    /**
     * @generated from enum value: OP_GT = 5;
     */
    RowPredicate_Op[RowPredicate_Op["GT"] = 5] = "GT";
    /**
     * @generated from enum value: OP_GTE = 6;
     */
    RowPredicate_Op[RowPredicate_Op["GTE"] = 6] = "GTE";
    /**
     * case-insensitive substring (SQL: LOWER(col) LIKE, widen-only escaped)
     *
     * @generated from enum value: OP_CONTAINS = 7;
     */
    RowPredicate_Op[RowPredicate_Op["CONTAINS"] = 7] = "CONTAINS";
    /**
     * value unset
     *
     * @generated from enum value: OP_IS_NULL = 8;
     */
    RowPredicate_Op[RowPredicate_Op["IS_NULL"] = 8] = "IS_NULL";
    /**
     * value unset
     *
     * @generated from enum value: OP_NOT_NULL = 9;
     */
    RowPredicate_Op[RowPredicate_Op["NOT_NULL"] = 9] = "NOT_NULL";
})(RowPredicate_Op || (RowPredicate_Op = {}));
/**
 * Describes the enum vitesse.v1.RowPredicate.Op.
 */
export const RowPredicate_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 14, 0);
/**
 * Describes the message vitesse.v1.RowFilter.
 * Use `create(RowFilterSchema)` to create a new message.
 */
export const RowFilterSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 15);
/**
 * Describes the message vitesse.v1.ReadRequest.
 * Use `create(ReadRequestSchema)` to create a new message.
 */
export const ReadRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 16);
/**
 * Describes the message vitesse.v1.ReadReply.
 * Use `create(ReadReplySchema)` to create a new message.
 */
export const ReadReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 17);
/**
 * Describes the message vitesse.v1.ObserveRequest.
 * Use `create(ObserveRequestSchema)` to create a new message.
 */
export const ObserveRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 18);
/**
 * Describes the message vitesse.v1.ObserveReply.
 * Use `create(ObserveReplySchema)` to create a new message.
 */
export const ObserveReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 19);
/**
 * Describes the message vitesse.v1.ApplyIntegrationRequest.
 * Use `create(ApplyIntegrationRequestSchema)` to create a new message.
 */
export const ApplyIntegrationRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 20);
/**
 * Describes the message vitesse.v1.ApplyIntegrationReply.
 * Use `create(ApplyIntegrationReplySchema)` to create a new message.
 */
export const ApplyIntegrationReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 21);
/**
 * Describes the message vitesse.v1.DeleteIntegrationRequest.
 * Use `create(DeleteIntegrationRequestSchema)` to create a new message.
 */
export const DeleteIntegrationRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 22);
/**
 * Describes the message vitesse.v1.DeleteIntegrationReply.
 * Use `create(DeleteIntegrationReplySchema)` to create a new message.
 */
export const DeleteIntegrationReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 23);
/**
 * Describes the message vitesse.v1.PutForwardRequest.
 * Use `create(PutForwardRequestSchema)` to create a new message.
 */
export const PutForwardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 24);
/**
 * Describes the message vitesse.v1.PutForwardReply.
 * Use `create(PutForwardReplySchema)` to create a new message.
 */
export const PutForwardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 25);
/**
 * Describes the message vitesse.v1.DeleteForwardRequest.
 * Use `create(DeleteForwardRequestSchema)` to create a new message.
 */
export const DeleteForwardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 26);
/**
 * Describes the message vitesse.v1.DeleteForwardReply.
 * Use `create(DeleteForwardReplySchema)` to create a new message.
 */
export const DeleteForwardReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 27);
/**
 * Describes the message vitesse.v1.IntegrationsSubscribeRequest.
 * Use `create(IntegrationsSubscribeRequestSchema)` to create a new message.
 */
export const IntegrationsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 28);
/**
 * Describes the message vitesse.v1.IntegrationEvent.
 * Use `create(IntegrationEventSchema)` to create a new message.
 */
export const IntegrationEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 29);
/**
 * @generated from enum vitesse.v1.IntegrationEvent.Op
 */
export var IntegrationEvent_Op;
(function (IntegrationEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    IntegrationEvent_Op[IntegrationEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: OP_PUT = 1;
     */
    IntegrationEvent_Op[IntegrationEvent_Op["PUT"] = 1] = "PUT";
    /**
     * @generated from enum value: OP_DELETE = 2;
     */
    IntegrationEvent_Op[IntegrationEvent_Op["DELETE"] = 2] = "DELETE";
})(IntegrationEvent_Op || (IntegrationEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.IntegrationEvent.Op.
 */
export const IntegrationEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 29, 0);
/**
 * Describes the message vitesse.v1.IntegrationsApplyRequest.
 * Use `create(IntegrationsApplyRequestSchema)` to create a new message.
 */
export const IntegrationsApplyRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 30);
/**
 * Describes the message vitesse.v1.IntegrationsDeleteRequest.
 * Use `create(IntegrationsDeleteRequestSchema)` to create a new message.
 */
export const IntegrationsDeleteRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 31);
/**
 * Describes the message vitesse.v1.IntegrationsPutForwardRequest.
 * Use `create(IntegrationsPutForwardRequestSchema)` to create a new message.
 */
export const IntegrationsPutForwardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 32);
/**
 * Describes the message vitesse.v1.IntegrationsDeleteForwardRequest.
 * Use `create(IntegrationsDeleteForwardRequestSchema)` to create a new message.
 */
export const IntegrationsDeleteForwardRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 33);
/**
 * Describes the message vitesse.v1.IntegrationsReadRequest.
 * Use `create(IntegrationsReadRequestSchema)` to create a new message.
 */
export const IntegrationsReadRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 34);
/**
 * Describes the message vitesse.v1.IntegrationsWriteRequest.
 * Use `create(IntegrationsWriteRequestSchema)` to create a new message.
 */
export const IntegrationsWriteRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 35);
/**
 * Describes the message vitesse.v1.IntegrationsLogsRequest.
 * Use `create(IntegrationsLogsRequestSchema)` to create a new message.
 */
export const IntegrationsLogsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 36);
/**
 * Describes the message vitesse.v1.SchemaNode.
 * Use `create(SchemaNodeSchema)` to create a new message.
 */
export const SchemaNodeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 37);
/**
 * Describes the message vitesse.v1.BrowseSchemaRequest.
 * Use `create(BrowseSchemaRequestSchema)` to create a new message.
 */
export const BrowseSchemaRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 38);
/**
 * Describes the message vitesse.v1.BrowseSchemaReply.
 * Use `create(BrowseSchemaReplySchema)` to create a new message.
 */
export const BrowseSchemaReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_integrations, 39);
/**
 * ViewKind — THE single classifier. It picks the viewport AND the behavior: who
 * owns search/pagination, and whether the indexer is an in-house cache or a thin
 * proxy. One enum gates everything; there are NO per-connector capability flags.
 *   TOPIC    — a live-value namespace with no native query engine (brokers,
 *              streams, OPC-UA). We materialize the namespace in-house and serve
 *              FTS + pagination ourselves (the symbol-indexer way). Bounded
 *              namespace (millions); the value firehose rides the value plane,
 *              never the index.                          → live-value TREE.
 *   TABLE    — a queryable recordset store (SQL, document, wide-column, search,
 *              time-series, object, KV). Search/sort/paginate are DELEGATED to the
 *              source's own engine (WHERE/LIMIT/native FTS); the indexer is a thin
 *              proxy. Scales to the source's limit.      → navigator + data grid.
 *   ENDPOINT — a request/response API (REST, +future GraphQL/gRPC). Invoke a named
 *              operation, get a response; no global index. → request builder + response.
 * Classified ONCE, by the source's nature (the dropdown grouping is the separate
 * `group` string). loadgen + OPC-UA are TOPIC — live-value sources, regardless of
 * the wire protocol they ride.
 *
 * @generated from enum vitesse.v1.ViewKind
 */
export var ViewKind;
(function (ViewKind) {
    /**
     * @generated from enum value: VIEW_KIND_UNSPECIFIED = 0;
     */
    ViewKind[ViewKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: VIEW_KIND_TOPIC = 1;
     */
    ViewKind[ViewKind["TOPIC"] = 1] = "TOPIC";
    /**
     * @generated from enum value: VIEW_KIND_TABLE = 2;
     */
    ViewKind[ViewKind["TABLE"] = 2] = "TABLE";
    /**
     * @generated from enum value: VIEW_KIND_ENDPOINT = 3;
     */
    ViewKind[ViewKind["ENDPOINT"] = 3] = "ENDPOINT";
})(ViewKind || (ViewKind = {}));
/**
 * Describes the enum vitesse.v1.ViewKind.
 */
export const ViewKindSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 0);
/**
 * NodeKind — what a single schema NODE is (per-node tree rendering only). The
 * VIEWPORT is chosen by IntegrationType.view_kind, NOT this; node_kind only tells
 * the tree whether a node expands (BRANCH) or is a leaf, and a leaf's flavor:
 *   BRANCH  — a container; browse(path) → children.   (tree node / nav group)
 *   VALUE   — a live-value leaf (observe/read/write by path).
 *   DATASET — a recordset leaf (read(path) → rows).
 *
 * @generated from enum vitesse.v1.NodeKind
 */
export var NodeKind;
(function (NodeKind) {
    /**
     * @generated from enum value: NODE_KIND_UNSPECIFIED = 0;
     */
    NodeKind[NodeKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: NODE_KIND_BRANCH = 1;
     */
    NodeKind[NodeKind["BRANCH"] = 1] = "BRANCH";
    /**
     * @generated from enum value: NODE_KIND_VALUE = 2;
     */
    NodeKind[NodeKind["VALUE"] = 2] = "VALUE";
    /**
     * @generated from enum value: NODE_KIND_DATASET = 3;
     */
    NodeKind[NodeKind["DATASET"] = 3] = "DATASET";
})(NodeKind || (NodeKind = {}));
/**
 * Describes the enum vitesse.v1.NodeKind.
 */
export const NodeKindSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 1);
/**
 * @generated from enum vitesse.v1.Direction
 */
export var Direction;
(function (Direction) {
    /**
     * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
     */
    Direction[Direction["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DIRECTION_READ = 1;
     */
    Direction[Direction["READ"] = 1] = "READ";
    /**
     * @generated from enum value: DIRECTION_WRITE = 2;
     */
    Direction[Direction["WRITE"] = 2] = "WRITE";
    /**
     * @generated from enum value: DIRECTION_READ_WRITE = 3;
     */
    Direction[Direction["READ_WRITE"] = 3] = "READ_WRITE";
})(Direction || (Direction = {}));
/**
 * Describes the enum vitesse.v1.Direction.
 */
export const DirectionSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_integrations, 2);
/**
 * @generated from service vitesse.v1.Integrations
 */
export const Integrations = /*@__PURE__*/ serviceDesc(file_vitesse_v1_integrations, 0);
//# sourceMappingURL=integrations_pb.js.map